import { CellContext } from "@tanstack/react-table";
import tw from "twin.macro";
import "styled-components/macro";

export const PreLineCell = ({ getValue }: CellContext<any, any>) => {
  return <div tw="whitespace-pre-line">{getValue()}</div>;
};
